export * from './Footer';

import Footer from './Footer';
export default Footer;
